import React, { useRef } from "react";
import "./Dashboard.css";
import "./List1.css";
import Chip from "@mui/material/Chip";
import filterIcon from "../../Assets/Icons/Vector.png";
import Stack from "@mui/material/Stack";
import SortIcon from "@mui/icons-material/Sort";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import toast, { Toaster } from "react-hot-toast";
import logo from "../../image/ayekart logo.png";
import { Box } from "@mui/system";
import { ListItemIcon, Popover } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Logout from "@mui/icons-material/Logout";
import { removeToken } from "../../redux/tokenSlice";
import authService from "../../services/auth.service";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { NavBar } from "../Navbar/NavBar";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import axios from "axios";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Loader from "../Loader";
import { Badge } from "react-bootstrap";
import Sidebar from "../Sidebar";

export const List1 = () => {
  const history = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [singleBatch, setSingleBatch] = useState({});
  const [batchesData, setBatchesData] = useState({});
  console.log(singleBatch);
  const [batchId, setBatchId] = useState({});
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dummy, setDummy] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [filterArray, setFilterArray] = useState([]);
  const addFilter = (eventVal) => {
    let arr = filterArray;
    if (arr.includes(eventVal)) {
      setDummy(!dummy);
      return;
    } else {
      arr.push(eventVal);
      setDummy(!dummy);
    }
    setFilterArray(arr);
  };

  const handleDelete = (chipToDelete) => {
    console.log(filterArray[0]?.split("-")?.[1]);
    let arr = filterArray;
    const index = arr.indexOf(chipToDelete);
    if (index !== -1) {
      arr.splice(index, 1);
    }
    setFilterArray(arr);
    setDummy(!dummy);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    authService.logout();
    dispatch(removeToken);
    history("/login");
  };

  // ------------------API Calls-------------------------------

  const getBatches = () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    let data = fetch(
      `/workflow/api/bulk/batches?start=${
        page * limit - limit
      }&length=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === true) {
          setBatchesData(res?.batches);
          setTotalResults(res?.batches?.count);
          setLoading(false);
        } else {
          setBatchesData({
            rows: [],
          });
          setTotalResults(0);
          setLoading(false);
        }
      });
  };

  const exportFile = (batch_id) => {
    const token = localStorage.getItem("token");
    axios
      .get(`/workflow/api/bulk/batches/export/${batch_id}`, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Batch_no_${batch_id}.csv`;
        link.click();
      });
  };

  const updatePatch = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    let obj = {
      level_1_status:
        singleBatch?.level_1_status === "Approved"
          ? "Approved"
          : singleBatch?.level_1_status === "Pending"
          ? "Pending"
          : "Corrections Done",
      level_2_status:
        singleBatch?.level_2_status === "Approved"
          ? "Approved"
          : singleBatch?.level_2_status === "Pending"
          ? "Pending"
          : "Corrections Done",
      level_3_status:
        singleBatch?.level_3_status === "Approved"
          ? "Approved"
          : singleBatch?.level_3_status === "Pending"
          ? "Pending"
          : "Corrections Done",
    };
    const res = await fetch(`/workflow/api/bulk/batches/${batchId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      method: "PATCH",
      body: JSON.stringify(obj),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === false) {
          toast.error(res?.message);
          setLoading(false);
        } else {
          setLoading(false);
          toast.success(res?.message);
          setDummy(!dummy);
        }
      });
  };

  const handleCSVUploadClick = async (dataFile) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", dataFile.file[0]);
    const res = await fetch("/workflow/api/bulk/batches/pre_orders", {
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === true) {
          updatePatch();
          setLoading(false);
          toast.success(res?.message);
        } else {
          setLoading(false);
          toast.error(res?.message);
        }
      });
  };
  const viewBatch = (itemParam) => {
    localStorage.setItem("single_batch", JSON.stringify(itemParam));
    history(`/pre-order-list/Batch/${itemParam?.id}`, {
      state: itemParam?.id,
    });
  };

  // ------------------API Calls ends here---------------------

  // -----------------------Pagination-------------------------
  const [data, setData] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsCount = 5;
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(5);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15);

  useEffect(() => {
    getBatches();
  }, [dummy, page, currentPage]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItem = batchesData?.rows?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };
  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage == number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  // -----------------Pagination Ends here---------------------

  return (
    <div className=" ">
      <div className="container-fluid mt-3 ">
        <Loader loading={loading} />

        <div className="container-fluid mt-3 pt-2  bg-white">
          <div className="row mx-0 filter-row mt-1 ">
            {/* <div className="col-2 text-start">
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => addFilter(e.target.value)}
            >
              <option hidden>Apply filter</option>
              <option value="level_1_status-Approved">Lvl1 Approved</option>
              <option value="level_2_status-Approved">Lvl2 Approved</option>
              <option value="level_3_status-Approved">Lvl3 Approved</option>
              <option value="level_1_status-Pending">Lvl1 Pending</option>
              <option value="level_2_status-Pending">Lvl2 Pending</option>
              <option value="level_3_status-Pending">Lvl3 Pending</option>
            </Form.Select>
          </div> */}

            <div className="col-10 text-start">
              {filterArray?.map((item, index) => (
                <Chip
                  key={index}
                  className="me-3 ps-3 pe-3 mb-2"
                  label={item}
                  onDelete={() => handleDelete(item)}
                />
              ))}
            </div>
          </div>

          <div className="outer-wrapper">
            <div className="table-wrapper-finance-grid mt-2">
              <table className="table">
                <thead className="List1-table-header" style={{backgroundColor:'#00213e'}}>
                  <tr>
                    <th className="header text-white" scope="col">
                      Date
                    </th>
                    <th className="header text-white" scope="col">
                      Batch
                    </th>
                    <th className="header text-white" scope="col">
                      Orders
                    </th>
                    <th className="header text-white" scope="col">
                      Total CP
                    </th>
                    <th className="header text-white" scope="col">
                      Total SP
                    </th>
                    <th className="header text-white" scope="col">
                      Margin (%)
                    </th>
                    <th className="header text-white" scope="col">
                      Level 1
                    </th>
                    <th className="header text-white" scope="col">
                      Level 2
                    </th>
                    <th className="header text-white" scope="col">
                      Level 3
                    </th>
                    <th className="header text-white" scope="col">
                      Tags
                    </th>
                    <th className="header text-white" scope="col">
                      Download
                    </th>
                    <th className="header text-white" scope="col">
                      Re-Upload
                    </th>
                    <th className="header text-white" scope="col">
                      <VisibilityIcon />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {batchesData && batchesData?.rows?.length > 0 ? (
                    batchesData?.rows?.map((item, index) => (
                      <tr key={index} className="list-table-row bg-white">
                        <td>{moment(item?.updated_at).format("DD/MM/yyyy")}</td>
                        <td>{item?.id}</td>
                        <td>{item?.total_orders}</td>
                        <td>{item?.total_cp}</td>
                        <td>{item?.total_sp}</td>
                        <td>
                          <Badge
                            className="ml-1"
                            variant={
                              Number(
                                ((item?.total_sp - item?.total_cp) /
                                  item?.total_sp) *
                                  100
                              ) < 3
                                ? "success"
                                : "danger"
                            }
                          >
                            {Number(
                              ((item?.total_sp - item?.total_cp) /
                                item?.total_sp) *
                                100
                            ).toFixed(2)}
                            %
                          </Badge>
                        </td>
                        <td
                          className={
                            item?.level_1_status === "Approved"
                              ? `fw-bold text-success`
                              : item?.level_1_status === "Rejected"
                              ? `fw-bold text-error`
                              : item?.level_1_status === "Pending"
                              ? `fw-bold text-warning`
                              : `fw-bold text-dark`
                          }
                        >
                          <small>{item?.level_1_status}</small>
                        </td>
                        <td
                          className={
                            item?.level_2_status === "Approved"
                              ? `fw-bold text-success`
                              : item?.level_2_status === "Rejected"
                              ? `fw-bold text-error`
                              : item?.level_2_status === "Pending"
                              ? `fw-bold text-warning`
                              : `fw-bold text-dark`
                          }
                        >
                          <small>{item?.level_2_status}</small>
                        </td>
                        <td
                          className={
                            item?.level_3_status === "Approved"
                              ? `fw-bold text-success`
                              : item?.level_3_status === "Rejected"
                              ? `fw-bold text-error`
                              : item?.level_3_status === "Pending"
                              ? `fw-bold text-warning`
                              : `fw-bold text-dark`
                          }
                        >
                          {" "}
                          <small>{item?.level_3_status}</small>
                          <br />
                        </td>
                        <td>{item?.tag ? item?.tag : "--NA--"}</td>
                        <td className="text-center">
                          <DownloadIcon
                            disabled
                            onClick={() => {
                              if (
                                userDetails?.email_address ===
                                "operations@ayekart.com"
                              ) {
                                exportFile(item?.id);
                              }
                            }}
                            role="button"
                            className={
                              userDetails?.email_address ===
                              "operations@ayekart.com"
                                ? "rounded-circle text-primary"
                                : "rounded-circle text-secondary opacity-25"
                            }
                          />
                        </td>
                        <td className="text-center">
                          <DriveFolderUploadIcon
                            onClick={() => {
                              setBatchId(item?.id);
                              setSingleBatch(item);
                            }}
                            role="button"
                            className={
                              userDetails?.email_address ===
                                "operations@ayekart.com" &&
                              (item?.level_1_status ===
                                "Sent For Corrections" ||
                                item?.level_2_status ===
                                  "Sent For Corrections" ||
                                item?.level_3_status === "Sent For Corrections")
                                ? "rounded-circle text-primary"
                                : "rounded-circle text-secondary opacity-25"
                            }
                            data-bs-toggle="modal"
                            data-bs-target={
                              userDetails?.email_address ===
                                "operations@ayekart.com" &&
                              (item?.level_1_status ===
                                "Sent For Corrections" ||
                                item?.level_2_status ===
                                  "Sent For Corrections" ||
                                item?.level_3_status === "Sent For Corrections")
                                ? `#uploadInBulkModalList1`
                                : "none"
                            }
                          />
                        </td>
                        <td className="text-center">
                          <KeyboardArrowRightIcon
                            role="button"
                            className="rounded-circle text-primary"
                            onClick={() => viewBatch(item)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <>
                      <h4 className="text-center">No records found</h4>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row mx-auto mt-3">
          <div className="col-sm-6 pt-2 d-flex justify-content-start">
            Showing {15 * currentPage - (15 - 1)} to {15 * currentPage} entries
            of {totalResults ? totalResults : ""}
            {console.log(totalResults)}
          </div>
          <div className="col-sm-6 d-flex justify-content-end">
            <ul className="pagination">
              <li className="page-item pt-1 pl-2 pr-2 border">
                <a
                  href="#overview-page"
                  className={currentPage !== pages[0] ? "show" : "hideBtn"}
                  onClick={(e) => handlePrevBtn(e)}
                >
                  Prev
                </a>
              </li>
              {renderPageNumbers}
              <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                <a
                  href="#overview-page"
                  className={currentPage !== pages.length ? "show" : "hideBtn"}
                  onClick={(e) => handleNextBtn(e)}
                >
                  Next
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* ------------Modal for Upload in Bulk------------- */}
        <div
          className="modal fade"
          id="uploadInBulkModalList1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="uploadInBulkModalList1"
          aria-hidden="false"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="uploadInBulkModalList1">
                  Re-upload Batch
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setSingleBatch({})}
                ></button>
              </div>
              <form onSubmit={handleSubmit(handleCSVUploadClick)}>
                <div className="modal-body">
                  <div className="row form-group">
                    <label
                      htmlFor="date"
                      className="col-sm-4 col-form-label pt-1"
                    >
                      Select CSV File
                    </label>
                    <div className="col-sm-8 pl-0 text-left">
                      <input
                        name="fileCSV"
                        type="file"
                        accept=".csv,.xlsx"
                        {...register("file", {
                          required: "File is required...",
                        })}
                      />
                    </div>
                  </div>
                  <div className="row d-flex justify-content-center text-danger">
                    {errors?.file ? errors?.file?.message : ""}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => setSingleBatch({})}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* -----------Modal for Upload in Bulk ends here---- */}
        <Toaster />
      </div>
    </div>
  );
};
